import React, { useContext, useEffect, useState } from "react";

import { Col, Row } from "react-bootstrap";
import PsContext from "../../context";
import Announcements from "./announcements";
import HomeSlider from "./homeSlider";
// import Slider from "./sliderstatic/slider"
// import Slider from 'react-slick';

import { SuperSEO } from "react-super-seo";
import { _HOME_PAGE_SETTINGS } from "../../models/fieldSettings";
import { lowerCase } from "../../utils";
import CampusTourVideo from "./campusTourVideo";
import WelcomeBanner from "./welcomeBanner";
import PrincipalMessage from "./principalMessage";
import Thirukural from "../thirukural";
import HomeAboutUsPage from "./homeAboutUsPage";
import HomeOurInstitutions from "./homeOurInstitutions";

const HomePage = (props) => {
  const context = useContext(PsContext);
  const [homePageSettings, setHomePageSettings] = useState([]);

  useEffect(() => {
    _HOME_PAGE_SETTINGS().then((res) => {
      if (res.status == "1") {
        setHomePageSettings(res.data);
      } else {
        console.log("Error on loading home page settings..");
      }
    });
  }, []);

  const checkComponentActive = (compId) => {
    let m = homePageSettings.find(
      (item) => lowerCase(item.component_id) == lowerCase(compId)
    );
    return m && m.show_on_site == "1" ? true : false;
  };

  const componentContent = (compId) => {
    let m = homePageSettings.find(
      (item) => lowerCase(item.component_id) == lowerCase(compId)
    );
    if (m && m.show_on_site == "1") {
      if (m && m.component_filter) {
        let jv = m.component_filter;
        if (jv && jv.length > 3) {
          let x = JSON.parse(jv.trim());
          return x;
        }
      }
    }
    return [];
  };

  return (
    <div>
      <SuperSEO
        title={context.settingValue("billheader_name")}
        description={context.settingValue("billheader_name")}
        lang="en"
      />

      {homePageSettings && (
        <>
          {checkComponentActive("home_slider_wide") && (
            <HomeSlider dataSource={componentContent("home_slider_wide")} />
          )}

          {checkComponentActive("home_about_us") && (
            <HomeAboutUsPage dataSource={componentContent("home_about_us")} />
          )}

          {/*checkComponentActive("vision_mission_announcement") && (
            <div className="container my-3">
              <Row>
                <Col md={8}>
                  <VisionMission />
                </Col>

                <Col md={4}>
                  <Announcements />
                </Col>
              </Row>
            </div>
          )*/}

          {checkComponentActive("principal_msg_announcement") && (
            <div className="container my-3">
              <Row>
                <Col md={8}>
                  <PrincipalMessage
                    dataSource={componentContent("principal_msg_announcement")}
                  />
                </Col>

                <Col md={4}>
                  <Announcements />
                </Col>
              </Row>
            </div>
          )}

          {checkComponentActive("thirukural") && (
            <Thirukural dataSource={componentContent("thirukural")} />
          )}

          {/* <div className="d-none d-sm-block">
        <Establishment />
      </div> */}

          {/* <TestimonialsList /> */}

          {/*<Testimonials />*/}

          {checkComponentActive("home_our_institutions") && (
            <HomeOurInstitutions
              dataSource={componentContent("home_our_institutions")}
            />
          )}

          {checkComponentActive("campus_tour_video") && (
            <CampusTourVideo
              dataSource={componentContent("campus_tour_video")}
            />
          )}
          <WelcomeBanner />
        </>
      )}
    </div>
  );
};

export default HomePage;
